import React from "react";

const CompanyName = () =>
  <ul className="gx-app-nav">
    <li>CYBER İSTANBUL - HRM</li>
  </ul>;

export default CompanyName;
